(function () {
  'use strict';

  // STARLESS currency accordion live sync 2026-09-28

  // STARLESS runtime refresh: late fixPage retries pruned 2026-08-13
  // STARLESS runtime refresh: legacy cart scans removed sync v11 2026-08-14
  // STARLESS runtime refresh: idempotent class sync 2026-08-14
  // STARLESS runtime refresh: connected language selector cache 2026-08-15
  // STARLESS runtime refresh: filtered observer attribute dispatch 2026-08-15
  // STARLESS runtime refresh: cached static page feature scopes 2026-08-15
  // STARLESS runtime refresh: cached static page feature nodes 2026-08-15
  // STARLESS runtime refresh: cached cart drawer references 2026-08-15
  // STARLESS runtime refresh: cached checkout descendants and drawer inner 2026-08-15
  // STARLESS runtime refresh: scoped child mutation dispatch 2026-08-15
  // STARLESS runtime refresh: debounced cart fallback fixes 2026-08-20
  if (window.__starlessLiveFixesLoaded) return;
  window.__starlessLiveFixesLoaded = true;

  var PAGE_COPY = {
    en: {
      trackingTitle: 'Track your order',
      trackingText: 'Enter your tracking number to view the latest delivery updates.',
      trackingInput: 'Tracking number',
      trackingButton: 'Track shipment',
      trackingHelp: ['Tracked shipping updates', 'Allow 24–48h after shipment', 'Need help? Contact us'],
      policy: '30-DAY MONEY-BACK GUARANTEE',
      trust: 'Secure checkout • Free tracked delivery • Easy returns',
      productAccordions: [
        {
          title: 'Shipping & Delivery',
          html: "<p>We ship quickly and reliably so your order arrives on time. Once your package is on its way, you'll receive full tracking details to keep you updated every step of the way. Delivery times may vary depending on your location.</p>"
        },
        {
          title: 'Refunds & Returns',
          html: '<p>Not 100% happy? Return eligible items within 30 days for a full refund or exchange.<br>Must be unused, with tags and original packaging. Contact us to start the process.<br>Refunds processed within 5–10 business days of receipt. Original shipping fees are non-refundable.<br>Some items (personalized, intimates, final sale) are non-returnable.</p>'
        }
      ]
    },
    fr: {
      trackingTitle: 'Suivre votre commande',
      trackingText: 'Saisissez votre numéro de suivi pour consulter les dernières mises à jour de livraison.',
      trackingInput: 'Numéro de suivi',
      trackingButton: 'Suivre l’envoi',
      trackingHelp: ['Mises à jour du suivi', 'Patientez 24 à 48 h après l’expédition', 'Besoin d’aide ? Contactez-nous'],
      policy: 'DROIT DE RÉTRACTATION DE 14 JOURS',
      trust: 'Paiement sécurisé • Livraison suivie offerte • Retours faciles',
      productAccordions: [
        {
          title: 'Expédition & livraison',
          html: '<p>Nous expédions rapidement et de manière fiable afin que votre commande arrive à temps. Dès que votre colis est en route, vous recevez toutes les informations de suivi pour rester informé à chaque étape. Les délais de livraison peuvent varier selon votre localisation.</p>'
        },
        {
          title: 'Retours & remboursements',
          html: '<p>Vous n’êtes pas entièrement satisfait ? Retournez les articles éligibles dans un délai de 30 jours pour obtenir un remboursement intégral ou un échange.<br>Les articles doivent être inutilisés, avec leurs étiquettes et dans leur emballage d’origine. Contactez-nous pour démarrer la procédure.<br>Les remboursements sont traités sous 5 à 10 jours ouvrés après réception. Les frais de livraison initiaux ne sont pas remboursables.<br>Certains articles (personnalisés, articles intimes et ventes finales) ne peuvent pas être retournés.</p>'
        }
      ]
    },
    de: {
      trackingTitle: 'Bestellung verfolgen',
      trackingText: 'Geben Sie Ihre Sendungsnummer ein, um die neuesten Lieferinformationen anzuzeigen.',
      trackingInput: 'Sendungsnummer',
      trackingButton: 'Sendung verfolgen',
      trackingHelp: ['Aktuelle Sendungsverfolgung', 'Bitte 24–48 Std. nach dem Versand warten', 'Brauchen Sie Hilfe? Kontaktieren Sie uns'],
      policy: '30-TAGE-GELD-ZURÜCK-GARANTIE',
      trust: 'Sicherer Checkout • Kostenloser Versand mit Sendungsverfolgung • Einfache Rückgabe',
      productAccordions: [
        {
          title: 'Versand & Lieferung',
          html: '<p>Wir versenden schnell und zuverlässig, damit deine Bestellung pünktlich ankommt. Sobald dein Paket unterwegs ist, erhältst du vollständige Informationen zur Sendungsverfolgung und bleibst bei jedem Schritt auf dem Laufenden. Die Lieferzeit kann je nach Standort variieren.</p>'
        },
        {
          title: 'Rückgabe & Rückerstattung',
          html: '<p>Nicht vollständig zufrieden? Du kannst berechtigte Artikel innerhalb von 30 Tagen gegen eine vollständige Rückerstattung oder einen Umtausch zurücksenden.<br>Die Artikel müssen unbenutzt, mit Etiketten und in der Originalverpackung sein. Kontaktiere uns, um die Rückgabe einzuleiten.<br>Rückerstattungen werden innerhalb von 5–10 Werktagen nach Eingang bearbeitet. Die ursprünglichen Versandkosten werden nicht erstattet.<br>Einige Artikel (personalisierte Artikel, Hygieneartikel und Schlussverkaufsartikel) sind von der Rückgabe ausgeschlossen.</p>'
        }
      ]
    },
    es: {
      trackingTitle: 'Seguir tu pedido',
      trackingText: 'Introduce tu número de seguimiento para consultar las últimas actualizaciones de entrega.',
      trackingInput: 'Número de seguimiento',
      trackingButton: 'Seguir el envío',
      trackingHelp: ['Actualizaciones del seguimiento', 'Espera entre 24 y 48 h después del envío', '¿Necesitas ayuda? Contáctanos'],
      policy: 'GARANTÍA DE DEVOLUCIÓN DE 30 DÍAS',
      trust: 'Pago seguro • Envío gratuito con seguimiento • Devoluciones sencillas',
      productAccordions: [
        {
          title: 'Envío y entrega',
          html: '<p>Enviamos de forma rápida y fiable para que tu pedido llegue a tiempo. En cuanto tu paquete esté en camino, recibirás toda la información de seguimiento para mantenerte al día en cada etapa. Los plazos de entrega pueden variar según tu ubicación.</p>'
        },
        {
          title: 'Devoluciones y reembolsos',
          html: '<p>¿No estás completamente satisfecho? Devuelve los artículos aptos en un plazo de 30 días para obtener un reembolso completo o un cambio.<br>Deben estar sin usar, con sus etiquetas y en el embalaje original. Contáctanos para iniciar el proceso.<br>Los reembolsos se tramitan en un plazo de 5 a 10 días laborables desde la recepción. Los gastos de envío originales no son reembolsables.<br>Algunos artículos (personalizados, íntimos y de venta final) no se pueden devolver.</p>'
        }
      ]
    }
  };

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function languageCode() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    var path = window.location.pathname.toLowerCase();

    if (lang.indexOf('fr') === 0 || path === '/fr' || path.indexOf('/fr/') === 0) return 'fr';
    if (lang.indexOf('de') === 0 || path === '/de' || path.indexOf('/de/') === 0) return 'de';
    if (lang.indexOf('es') === 0 || path === '/es' || path.indexOf('/es/') === 0) return 'es';
    return 'en';
  }

  function copyForPage() {
    return PAGE_COPY[languageCode()] || PAGE_COPY.en;
  }

  function isFrench() {
    return languageCode() === 'fr';
  }

  function preventTranslation(element) {
    if (!element) return;
    if (element.getAttribute('translate') !== 'no') element.setAttribute('translate', 'no');
  }

  function installStyles() {
    if (document.getElementById('starless-live-fixes-style')) return;

    var style = document.createElement('style');
    style.id = 'starless-live-fixes-style';
    style.textContent = [
      '#CartDrawer .starless-policy-banner{display:flex!important;align-items:center!important;justify-content:center!important;width:calc(100% - 32px)!important;min-height:48px!important;margin:8px 16px 14px!important;padding:10px 18px!important;border:1px solid rgba(199,164,81,.22)!important;border-radius:999px!important;background:#f6efdd!important;color:#7a6124!important;-webkit-text-fill-color:#7a6124!important;font-size:13px!important;font-weight:900!important;line-height:1.15!important;letter-spacing:.08em!important;text-align:center!important;text-transform:uppercase!important;box-sizing:border-box!important;}',
      '#CartDrawer .starless-trust-line{display:block!important;margin:12px 0 0!important;padding:0 8px!important;color:rgba(17,17,17,.58)!important;-webkit-text-fill-color:rgba(17,17,17,.58)!important;font-size:13px!important;font-weight:500!important;line-height:1.35!important;letter-spacing:0!important;text-align:center!important;}',
      '#CartDrawer #CartDrawer-Checkout,#CartDrawer .cart__checkout-button,#CartDrawer button[name="checkout"]{--color-button:199, 164, 81!important;--color-button-text:17, 17, 17!important;width:100%!important;min-height:60px!important;height:60px!important;padding:0 24px!important;border:0!important;border-radius:18px!important;background:#c7a451!important;background-color:#c7a451!important;background-image:none!important;color:#111!important;-webkit-text-fill-color:#111!important;box-shadow:0 12px 28px rgba(199,164,81,.24)!important;font-size:16px!important;font-weight:900!important;line-height:1!important;letter-spacing:.08em!important;text-transform:uppercase!important;transform:none!important;}',
      '#CartDrawer #CartDrawer-Checkout::before,#CartDrawer #CartDrawer-Checkout::after,#CartDrawer .cart__checkout-button::before,#CartDrawer .cart__checkout-button::after,#CartDrawer button[name="checkout"]::before,#CartDrawer button[name="checkout"]::after{content:none!important;display:none!important;background:none!important;box-shadow:none!important;}',
      '#CartDrawer #CartDrawer-Checkout .button__label,#CartDrawer .cart__checkout-button .button__label,#CartDrawer button[name="checkout"] .button__label{color:#111!important;-webkit-text-fill-color:#111!important;font:inherit!important;}',
      '#CartDrawer #CartDrawer-Checkout:hover,#CartDrawer .cart__checkout-button:hover,#CartDrawer button[name="checkout"]:hover{background:#d4b25f!important;background-color:#d4b25f!important;transform:translateY(-1px)!important;}',
      '#CartDrawer .drawer__inner.starless-empty-cart>:not(.drawer__inner-empty){display:none!important;}',
      '#CartDrawer .drawer__inner.starless-empty-cart>.drawer__inner-empty{display:flex!important;width:100%!important;min-height:100%!important;position:relative!important;}',
      '#CartDrawer .drawer__inner.starless-empty-cart .drawer__inner-empty .drawer__close{position:absolute!important;top:18px!important;right:18px!important;left:auto!important;bottom:auto!important;width:46px!important;min-width:46px!important;height:46px!important;min-height:46px!important;margin:0!important;padding:0!important;z-index:20!important;}',
      '.starless-color-heading-force,.starless-track-heading-force{display:none!important;}',
      'body.template-product [id^="MainProduct-"] .starless-color-label{display:inline-flex!important;align-items:baseline!important;gap:9px!important;width:auto!important;margin:0 0 16px!important;padding:9px 13px!important;border:1px solid rgba(199,164,81,.22)!important;border-radius:999px!important;background:rgba(199,164,81,.07)!important;font-family:var(--font-body-family)!important;font-size:0!important;line-height:1!important;letter-spacing:0!important;white-space:nowrap!important;text-transform:none!important;}',
      'body.template-product [id^="MainProduct-"] .starless-color-label::before{margin:0!important;font-family:inherit!important;font-size:12px!important;font-weight:700!important;line-height:1!important;letter-spacing:.11em!important;text-transform:uppercase!important;opacity:.68!important;}',
      'body.template-product [id^="MainProduct-"] .starless-color-label span{display:inline!important;margin:0!important;font-size:0!important;}',
      'body.template-product [id^="MainProduct-"] .starless-color-label span::after{font-family:inherit!important;font-size:15px!important;font-weight:800!important;line-height:1!important;letter-spacing:0!important;text-transform:none!important;}',
      '[class*="track-order-starless-"] .track-order-form .center>.title{display:block!important;visibility:visible!important;opacity:1!important;width:100%!important;margin:0 0 16px!important;padding:0!important;font-family:var(--font-heading-family)!important;font-size:clamp(36px,4vw,56px)!important;font-weight:700!important;line-height:1.05!important;letter-spacing:-.035em!important;text-align:center!important;text-transform:none!important;}',
      '[class*="track-order-starless-"] .track-order-form .center>p{margin:0 auto!important;}',
      'html.starless-cart-drawer-open .starless-floating-language{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}',
      'body.template-product [id^="MainProduct-"] .starless-localized-product-accordion .accordion__title{font-family:var(--font-heading-family)!important;font-size:22px!important;font-weight:800!important;line-height:1.12!important;letter-spacing:-.02em!important;text-transform:none!important;}',
      'body.template-product [id^="MainProduct-"] .starless-localized-product-accordion .accordion__content,body.template-product [id^="MainProduct-"] .starless-localized-product-accordion .accordion__content p{font-family:var(--font-body-family)!important;font-size:15px!important;font-weight:400!important;line-height:1.6!important;letter-spacing:0!important;text-transform:none!important;}',
      'body.template-product [id^="MainProduct-"] .starless-localized-product-accordion .accordion__content p{margin:0!important;}',
      '@media(max-width:749px){body.template-product [id^="MainProduct-"] .starless-color-label{margin-bottom:13px!important;padding:8px 11px!important;}body.template-product [id^="MainProduct-"] .starless-color-label::before{font-size:11px!important;}body.template-product [id^="MainProduct-"] .starless-color-label span::after{font-size:14px!important;}[class*="track-order-starless-"] .track-order-form .center>.title{margin-bottom:12px!important;font-size:32px!important;}body.template-product [id^="MainProduct-"] .starless-localized-product-accordion .accordion__title{font-size:18px!important;line-height:1.2!important;}}',
      '@media(max-width:480px){#CartDrawer .starless-policy-banner{width:calc(100% - 24px)!important;min-height:44px!important;margin:6px 12px 12px!important;padding:9px 12px!important;font-size:11.5px!important;}#CartDrawer .starless-trust-line{font-size:12px!important;}#CartDrawer #CartDrawer-Checkout,#CartDrawer .cart__checkout-button,#CartDrawer button[name="checkout"]{min-height:56px!important;height:56px!important;border-radius:16px!important;font-size:15px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  var pageScopes = {
    product: false,
    trackingForms: [],
    roadTripTitles: [],
    productAccordions: []
  };

  function refreshPageScopes() {
    pageScopes.product = Boolean(document.body && document.body.classList.contains('template-product'));
    pageScopes.trackingForms = Array.prototype.slice.call(
      document.querySelectorAll('[class*="track-order-starless-"] .track-order-form')
    );
    pageScopes.roadTripTitles = Array.prototype.slice.call(
      document.querySelectorAll('[class*="rn-moments-card-title-"]')
    );
    pageScopes.productAccordions = pageScopes.product ? Array.prototype.slice.call(
      document.querySelectorAll('[id^="MainProduct-"] .accordion')
    ).filter(function (accordion) {
      if (accordion.classList.contains('starless-description-accordion') || accordion.classList.contains('starless-auto-accordion') || accordion.classList.contains('starless-unified-description-accordion')) return false;
      var title = accordion.querySelector('.accordion__title');
      if (!title) return false;
      var text = normalize(title.textContent);
      return /(shipping|delivery|expédition|livraison|versand|lieferung|refund|return|retour|remboursement|rückgabe|rücksendung|rückerstattung|envío|entrega|devolución|devoluciones|reembolso|reembolsos)/i.test(text);
    }) : [];
  }

  function fixProductColorLabel() {
    if (!pageScopes.product) return;
    document.querySelectorAll('.starless-color-heading-force').forEach(function (node) {
      node.remove();
    });
  }

  function fixTrackingSection() {
    if (!pageScopes.trackingForms.length) return;
    var copy = copyForPage();

    pageScopes.trackingForms.forEach(function (form) {
      if (!form.isConnected) return;
      form.querySelectorAll('.starless-track-heading-force').forEach(function (node) {
        node.remove();
      });

      var center = form.querySelector('.center');
      if (!center) return;

      var title = center.querySelector(':scope > .title, :scope > h1, :scope > h2, :scope > h3');
      if (!title) {
        title = document.createElement('h2');
        title.className = 'title h1 title-with-highlight';
        center.insertBefore(title, center.firstChild);
      }
      if (title.textContent !== copy.trackingTitle) title.textContent = copy.trackingTitle;
      if (title.style.getPropertyValue('display') !== 'block' || title.style.getPropertyPriority('display') !== 'important') title.style.setProperty('display', 'block', 'important');
      if (title.style.getPropertyValue('visibility') !== 'visible' || title.style.getPropertyPriority('visibility') !== 'important') title.style.setProperty('visibility', 'visible', 'important');
      if (title.style.getPropertyValue('opacity') !== '1' || title.style.getPropertyPriority('opacity') !== 'important') title.style.setProperty('opacity', '1', 'important');
      preventTranslation(title);

      var description = center.querySelector('p');
      if (description) {
        if (description.textContent !== copy.trackingText) description.textContent = copy.trackingText;
        preventTranslation(description);
      }

      var input = form.querySelector('#YQNum, input[name="track-order-number"]');
      if (input) {
        if (input.placeholder !== copy.trackingInput) input.placeholder = copy.trackingInput;
        if (input.getAttribute('aria-label') !== copy.trackingInput) input.setAttribute('aria-label', copy.trackingInput);
        preventTranslation(input);
      }

      var label = form.querySelector('label[for="YQNum"], .field__label');
      if (label) {
        if (label.textContent !== copy.trackingInput) label.textContent = copy.trackingInput;
        preventTranslation(label);
      }

      var button = form.querySelector('.contact__button input[type="button"], input.button[type="button"], button.button');
      if (button) {
        if ('value' in button && button.value !== copy.trackingButton) button.value = copy.trackingButton;
        if (button.tagName === 'BUTTON' && button.textContent !== copy.trackingButton) button.textContent = copy.trackingButton;
        if (button.getAttribute('aria-label') !== copy.trackingButton) button.setAttribute('aria-label', copy.trackingButton);
        preventTranslation(button);
      }

      var helpSpans = form.querySelectorAll('.track-order-help span');
      copy.trackingHelp.forEach(function (text, index) {
        if (!helpSpans[index]) return;
        if (helpSpans[index].textContent !== text) helpSpans[index].textContent = text;
        preventTranslation(helpSpans[index]);
      });
    });
  }

  function fixProductAccordions() {
    if (!pageScopes.product || !pageScopes.productAccordions.length) return;
    var copy = copyForPage();
    if (!copy.productAccordions) return;

    copy.productAccordions.forEach(function (item, index) {
      var accordion = pageScopes.productAccordions[index];
      if (!accordion || !accordion.isConnected) return;

      ['starless-auto-accordion', 'starless-description-accordion', 'starless-localized-product-accordion'].forEach(function (className) {
        if (!accordion.classList.contains(className)) accordion.classList.add(className);
      });

      var title = accordion.querySelector('.accordion__title');
      var content = accordion.querySelector('.accordion__content');

      if (title) {
        if (title.textContent !== item.title) title.textContent = item.title;
        preventTranslation(title);
      }

      if (content) {
        if (content.innerHTML.trim() !== item.html.trim()) content.innerHTML = item.html;
        preventTranslation(content);
      }
    });
  }

  function removeDuplicateNodes(drawer) {
    drawer.querySelectorAll('.starless-cart-policy-final, .starless-cart-trust-final').forEach(function (node) {
      node.remove();
    });

    var policies = drawer.querySelectorAll('.starless-policy-banner');
    Array.prototype.slice.call(policies, 1).forEach(function (node) {
      node.remove();
    });

    var trusts = drawer.querySelectorAll('.starless-trust-line');
    Array.prototype.slice.call(trusts, 1).forEach(function (node) {
      node.remove();
    });
  }

  function ensurePolicyBanner(drawer) {
    var paymentBlock = drawer.querySelector('.payment-badges-block, .payment-badges');
    if (!paymentBlock) return;

    var existing = drawer.querySelector('.starless-policy-banner');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'starless-policy-banner';
      paymentBlock.parentNode.insertBefore(existing, paymentBlock);
    }
    var policy = copyForPage().policy;
    if (existing.textContent !== policy) existing.textContent = policy;
    preventTranslation(existing);
  }

  function ensureTrustLine(drawer) {
    var ctas = drawer.querySelector('.cart__ctas, .cart-drawer__ctas');
    if (!ctas) return;

    var existing = ctas.querySelector('.starless-trust-line');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'starless-trust-line';
      ctas.appendChild(existing);
    }
    var trust = copyForPage().trust;
    if (existing.textContent !== trust) existing.textContent = trust;
    preventTranslation(existing);
  }

  function replaceTextNodes(root, replacer) {
    if (!root || !replacer) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var original = textNode.nodeValue;
      var updated = replacer(original);
      if (updated !== original) textNode.nodeValue = updated;
    });
  }

  function fixSpanishCartCopy(drawer) {
    if (languageCode() !== 'es') return;

    drawer.querySelectorAll('.product-option, .cart-item__details dl, .cart-item__details dt, .cart-item__details dd, [class*="product-option" i]').forEach(function (element) {
      replaceTextNodes(element, function (text) {
        return text
          .replace(/\b(?:Color|Farbe|Couleur)\s*:\s*(?:Black|Schwarz|Noir|Negro)\b/gi, 'Color: Negro')
          .replace(/\b(?:Color|Farbe|Couleur)\s*:\s*Beige\b/gi, 'Color: Beige')
          .replace(/^\s*(?:Black|Schwarz|Noir)\s*$/gi, 'Negro');
      });
    });

    replaceTextNodes(drawer, function (text) {
      return text
        .replace(/Cart reserved for another\s+(\d{1,2}:\d{2})\s+minutes?!/gi, '¡Carrito reservado durante otros $1 minutos!')
        .replace(/Cart reserved for\s+(\d{1,2}:\d{2})\s+more minutes?!/gi, '¡Carrito reservado durante otros $1 minutos!')
        .replace(/Your cart/gi, 'Tu carrito')
        .replace(/View cart/gi, 'Ver carrito')
        .replace(/Continue shopping/gi, 'Seguir comprando');
    });
  }

  var checkoutButton = null;
  var checkoutButtonDescendants = null;

  function getCheckoutButton(drawer) {
    if (checkoutButton && checkoutButton.isConnected) return checkoutButton;
    checkoutButton = drawer.querySelector('#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]');
    checkoutButtonDescendants = checkoutButton ? checkoutButton.getElementsByTagName('*') : null;
    return checkoutButton;
  }

  function styleCheckoutButton(drawer) {
    var button = getCheckoutButton(drawer);
    if (!button) return;

    var properties = {
      '--color-button': '199, 164, 81',
      '--color-button-text': '17, 17, 17',
      'width': '100%',
      'min-height': '60px',
      'height': '60px',
      'padding': '0 24px',
      'border': '0',
      'border-radius': '18px',
      'background': 'none #c7a451',
      'color': '#111111',
      '-webkit-text-fill-color': '#111111',
      'box-shadow': '0 12px 28px rgba(199, 164, 81, 0.24)',
      'font-size': '16px',
      'font-weight': '900',
      'line-height': '1',
      'letter-spacing': '0.08em',
      'text-transform': 'uppercase',
      'transform': 'none'
    };

    if (button.__starlessCheckoutStyleSnapshot !== button.style.cssText) {
      Object.keys(properties).forEach(function (property) {
        button.style.setProperty(property, properties[property], 'important');
      });
      button.__starlessCheckoutStyleSnapshot = button.style.cssText;
    }

    Array.prototype.forEach.call(checkoutButtonDescendants || [], function (child) {
      if (child.__starlessCheckoutStyleSnapshot === child.style.cssText) return;
      child.style.setProperty('color', '#111111', 'important');
      child.style.setProperty('-webkit-text-fill-color', '#111111', 'important');
      child.__starlessCheckoutStyleSnapshot = child.style.cssText;
    });
  }

  var cartDrawer = null;
  var cartDrawerHost = null;
  var cartDrawerInner = null;

  function getCartDrawer() {
    if (cartDrawer && cartDrawer.isConnected) return cartDrawer;
    cartDrawer = document.querySelector('#CartDrawer');
    cartDrawerHost = cartDrawer ? cartDrawer.closest('cart-drawer') : null;
    cartDrawerInner = null;
    checkoutButton = null;
    checkoutButtonDescendants = null;
    return cartDrawer;
  }

  function getCartDrawerHost(drawer) {
    if (cartDrawerHost && cartDrawerHost.isConnected) return cartDrawerHost;
    var currentDrawer = drawer || getCartDrawer();
    cartDrawerHost = currentDrawer ? currentDrawer.closest('cart-drawer') : null;
    return cartDrawerHost;
  }

  function getCartDrawerInner(drawer) {
    if (cartDrawerInner && cartDrawerInner.isConnected) return cartDrawerInner;
    var currentDrawer = drawer || getCartDrawer();
    cartDrawerInner = currentDrawer ? currentDrawer.querySelector('.drawer__inner') : null;
    return cartDrawerInner;
  }

  function fixEmptyCart(drawer) {
    var inner = getCartDrawerInner(drawer);
    if (!inner) return;
    var emptyBlock = inner.querySelector(':scope > .drawer__inner-empty');
    var host = getCartDrawerHost(drawer);
    var empty = Boolean(emptyBlock) || Boolean(host && host.classList.contains('is-empty'));
    if (inner.classList.contains('starless-empty-cart') !== empty) {
      inner.classList.toggle('starless-empty-cart', empty);
    }
  }

  function fixRoadTrips() {
    if (!pageScopes.roadTripTitles.length || !isFrench()) return;
    pageScopes.roadTripTitles.forEach(function (title) {
      if (!title.isConnected) return;
      var text = normalize(title.textContent);
      if (text === 'Trajets en voiture' || text === 'Longs trajets') title.textContent = 'Road trips';
      if (text === 'Long trajet') title.textContent = 'Road trip';
    });
  }

  function cartDrawerIsOpen() {
    var drawer = getCartDrawer();
    if (!drawer) return false;
    var host = getCartDrawerHost(drawer);
    return Boolean(
      (host && (host.classList.contains('active') || host.hasAttribute('open'))) ||
      drawer.classList.contains('active') ||
      drawer.hasAttribute('open') ||
      drawer.getAttribute('aria-hidden') === 'false'
    );
  }

  function syncFloatingLanguageSelector() {
    var open = cartDrawerIsOpen();
    if (document.documentElement.classList.contains('starless-cart-drawer-open') !== open) {
      document.documentElement.classList.toggle('starless-cart-drawer-open', open);
    }
  }

  function fixStaticPage() {
    installStyles();
    fixRoadTrips();
    fixProductColorLabel();
    fixTrackingSection();
    fixProductAccordions();
  }

  function fixCart() {
    syncFloatingLanguageSelector();

    var drawer = getCartDrawer();
    if (!drawer) return;

    fixEmptyCart(drawer);
    fixSpanishCartCopy(drawer);
    styleCheckoutButton(drawer);
    removeDuplicateNodes(drawer);
    ensurePolicyBanner(drawer);
    ensureTrustLine(drawer);
  }

  function fixPage() {
    fixStaticPage();
    fixCart();
  }

  function scheduleFixes() {
    [0, 50, 150, 300].forEach(function (delay) {
      window.setTimeout(fixPage, delay);
    });
  }

  var cartFixFallbackTimer = null;

  function scheduleCartFixes() {
    fixCart();
    window.clearTimeout(cartFixFallbackTimer);
    cartFixFallbackTimer = window.setTimeout(fixCart, 180);
  }

  function boot() {
    refreshPageScopes();
    getCartDrawer();
    fixPage();

    document.addEventListener('click', function (event) {
      if (event.target.closest('#cart-icon-bubble, [href*="/cart"], [data-cart], cart-drawer, .drawer__close')) {
        scheduleCartFixes();
      }
    }, true);

    ['cart:updated', 'cart:refresh', 'cart-drawer:open', 'cart-drawer:close'].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleCartFixes);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        refreshPageScopes();
        scheduleFixes();
      });
    }

    var host = getCartDrawerHost();
    if (!host) return;

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        fixCart();
      });
    });

    observer.observe(host, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'aria-expanded']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();